import { useQuery } from '@tanstack/react-query';
import { useContext, useState } from 'react';
import { COOKIE_CONSENT_QUERY_KEY, getCookies } from '@/queries/cookie-consent';
import { AppContext } from '@/contexts/app-context';

export function useCookies() {
    const context = useContext(AppContext);
    const COOKIE_PAGE = '/cookie-modal';
    const [isOpen, setIsOpen] = useState(false);

    const cookiesData = useQuery({
        queryKey: [COOKIE_CONSENT_QUERY_KEY],
        queryFn: () => getCookies(context),
        enabled: false,
    });

    return {
        cookiesData,
        COOKIE_PAGE,
        isOpen,
        setIsOpen,
    };
}
